import { useState } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

export const SubmissionsDifferFromResponsesBanner = () => {
  const [showBanner, setShowBanner] = useState(true);

  return showBanner ? (
    <Banner className="body-s mb-2" kind="info" onDismiss={() => setShowBanner(false)}>
      {t("page_detail_view.submissions_differ_from_responses_banner")}
    </Banner>
  ) : null;
};
